export const docNoFormMixin = {
  data() {
    return {
      today: new Date(),
      // cDocument
      branch1C: '',
      branch2C: '',
      polType1C: '',
      polType2C: '',
      polType3C: '',
      year2C: null,
      year4C: null,
      dept1C: '',
      busSrc1C: '',
      disc: false,
      layoutForm: {
        totalLength: 0,
        expLayout: ''
      },
      maxLength: 0,
      keyFactList: [],
      header: '',
      loading: false,
      submitting: false,
      month2C: null
    }
  },
  watch: {},
  computed: {
    menu() {
      return this.$store.state.docFormatParam.menu
    },
    docTypeList() {
      return [
        { label: 'C - Claim No.', value: 'C' },
        { label: 'P - Policy No.', value: 'P' },
        { label: 'V - Voyage No.', value: 'V' },
        { label: 'H - Vessel No.', value: 'H' }
      ]
    },
    formIdList() {
      return [
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
        { label: '07', value: 7 },
        { label: '08', value: 8 },
        { label: '09', value: 9 },
        { label: '10', value: 10 }
      ]
    },
    keyFactListC() {
      return [
        { label: 'NA - Not Applicable', value: 'NA', value2: 0, value3: '' },
        { label: '701 - Direct / RI Inwards', value: '701', value2: 1, value3: 'D' },
        { label: '711 - Branch (1C)', value: '711', value2: 1, value3: this.branch1C },
        { label: '712 - Branch (2C)', value: '712', value2: 2, value3: this.branch2C },
        { label: '721 - Policy Type (1C)', value: '721', value2: 1, value3: this.polType1C },
        { label: '722 - Policy Type (2C)', value: '722', value2: 2, value3: this.polType2C },
        { label: '723 - Policy Type (3C)', value: '723', value2: 3, value3: this.polType3C },
        { label: '731 - Notification Year (yy)', value: '731', value2: 2, value3: this.year2C },
        { label: '732 - Notification Year (yyyy)', value: '732', value2: 4, value3: this.year4C },
        { label: '733 - Transaction Year (yy)', value: '733', value2: 2, value3: this.year2C },
        { label: '734 - Transaction Year (yyyy)', value: '734', value2: 4, value3: this.year4C },
        { label: '735 - Loss Year (yy)', value: '735', value2: 2, value3: this.year2C },
        { label: '736 - Loss Year (yyyy)', value: '736', value2: 4, value3: this.year4C },
        { label: '751 - Sequence No. (99999)', value: '751', value2: 5, value3: '99999' },
        { label: '752 - Sequence No. (9999)', value: '752', value2: 4, value3: '9999' },
        { label: '761 - Department (1C)', value: '761', value2: 1, value3: this.dept1C },
        { label: '771 - Business Source (1C)', value: '771', value2: 1, value3: this.busSrc1C },
        { label: '781 - Notification Month (mm)', value: '781', value2: 2, value3: this.month2C },
        { label: '782 - Transaction Month (mm)', value: '782', value2: 2, value3: this.month2C },
        { label: '783 - Loss Month (mm)', value: '783', value2: 2, value3: this.month2C }
      ]
    },
    keyFactListP() {
      return [
        { label: 'NA - Not Applicable', value: 'NA', value2: 0, value3: '' },
        { label: '101 - Direct / RI Inwards', value: '101', value2: 1, value3: 'D' },
        { label: '111 - Branch (1C)', value: '111', value2: 1, value3: this.branch1C },
        { label: '112 - Branch (2C)', value: '112', value2: 2, value3: this.branch2C },
        { label: '121 - Policy Type (1C)', value: '121', value2: 1, value3: this.polType1C },
        { label: '122 - Policy Type (2C)', value: '122', value2: 2, value3: this.polType2C },
        { label: '123 - Policy Type (3C)', value: '123', value2: 3, value3: this.polType3C },
        { label: '131 - Underwriting Year (yy)', value: '131', value2: 2, value3: this.year2C },
        { label: '132 - Underwriting Year (yyyy)', value: '132', value2: 4, value3: this.year4C },
        { label: '133 - Transaction Year (yy)', value: '133', value2: 2, value3: this.year2C },
        { label: '134 - Transaction Year (yyyy)', value: '134', value2: 4, value3: this.year4C },
        { label: '141 - Renewal Count', value: '141', value2: 2, value3: '00' },
        { label: '151 - Sequence No. (999999)', value: '151', value2: 6, value3: '999999' },
        { label: '161 - Department (1C)', value: '161', value2: 1, value3: this.dept1C },
        { label: '171 - Business Source (1C)', value: '171', value2: 1, value3: this.busSrc1C }
      ]
    },
    keyFactListV() {
      return [
        { label: 'NA - Not Applicable', value: 'NA', value2: 0 },
        { label: '501 - Vessel No.', value: '501' }
      ]
    },
    keyFactListH() {
      return [{ label: 'NA - Not Applicable', value: 'NA', value2: 0 }]
    }
  },
  methods: {
    async doInitDocNoForm(docNoFormForm) {
      this.resetMessages()
      this.year2C = parseInt(this.today.getFullYear()) - 2000
      this.year4C = this.today.getFullYear()
      this.month2C = ('' + this.today.getMonth()).padStart(2, '0')
      this.getTop1Value().then(success => {
        if (success) {
          this.getKeyFactList(docNoFormForm)
          this.getExpectedLengthLayout(docNoFormForm)
          this.newDocNoForm = false
          this.docNoFormReview = true
          this.loading = false
        }
      })
    },
    async getTop1Value() {
      const apiURI = this.menu.getTop1Value
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.branch1C = data.branch.substring(0, 1)
          this.branch2C = data.branch.substring(0, 2)
          this.polType1C = data.polType.substring(0, 1)
          this.polType2C = data.polType.substring(0, 2)
          this.polType3C = data.polType.substring(0, 3)
          this.dept1C = data.dept.substring(0, 1)
          this.busSrc1C = data.busSrc.substring(0, 1)
        }
        return true
      }
      return false
    },
    getKeyFactList(docNoFormForm) {
      this.keyFactList = []
      if (docNoFormForm.docType === 'P') {
        this.keyFactList = this.keyFactListP
      } else if (docNoFormForm.docType === 'C') {
        this.keyFactList = this.keyFactListC
      } else if (docNoFormForm.docType === 'V') {
        this.keyFactList = this.keyFactListV
      } else {
        this.keyFactList = this.keyFactListH
      }
      if (this.newDocNoForm) {
        docNoFormForm.keyFact1Type = 'NA'
        docNoFormForm.keyFact2Type = 'NA'
        docNoFormForm.keyFact3Type = 'NA'
        docNoFormForm.keyFact4Type = 'NA'
        docNoFormForm.keyFact5Type = 'NA'
        docNoFormForm.keyFact6Type = 'NA'
        docNoFormForm.inclFact1seqNo = false
        docNoFormForm.inclFact2seqNo = false
        docNoFormForm.inclFact3seqNo = false
        docNoFormForm.inclFact4seqNo = false
        docNoFormForm.inclFact5seqNo = false
        docNoFormForm.inclFact6seqNo = false
        if (docNoFormForm.docType === 'V') {
          docNoFormForm.formId = 1
          docNoFormForm.keyFact1Type = '501'
          docNoFormForm.inclFact1seqNo = true
          this.disc = true
        } else if (docNoFormForm.docType === 'H') {
          docNoFormForm.formId = 1
          this.disc = true
        } else {
          this.disc = false
        }
      }
    },
    async getExpectedLengthLayout(docNoFormForm) {
      this.layoutForm.totalLength = 0
      this.layoutForm.expLayout = ''
      if (docNoFormForm.docType !== 'V' && docNoFormForm.docType !== 'H') {
        if (docNoFormForm.keyFact1Type !== 'NA') {
          this.layoutForm.totalLength += this.getValue('length', docNoFormForm.keyFact1Type)
          this.layoutForm.expLayout += this.getValue('layout', docNoFormForm.keyFact1Type)
          if (docNoFormForm.keyFact1Type === '751' || docNoFormForm.keyFact1Type === '151') {
            docNoFormForm.inclFact1seqNo = false
          }
        }
        if (docNoFormForm.keyFact2Type !== 'NA') {
          this.layoutForm.totalLength += this.getValue('length', docNoFormForm.keyFact2Type)
          this.layoutForm.expLayout += this.getValue('layout', docNoFormForm.keyFact2Type)
          if (docNoFormForm.keyFact2Type === '751' || docNoFormForm.keyFact2Type === '151') {
            docNoFormForm.inclFact2seqNo = false
          }
        }
        if (docNoFormForm.keyFact3Type !== 'NA') {
          this.layoutForm.totalLength += this.getValue('length', docNoFormForm.keyFact3Type)
          this.layoutForm.expLayout += this.getValue('layout', docNoFormForm.keyFact3Type)
          if (docNoFormForm.keyFact3Type === '751' || docNoFormForm.keyFact3Type === '151') {
            docNoFormForm.inclFact3seqNo = false
          }
        }
        if (docNoFormForm.keyFact4Type !== 'NA') {
          this.layoutForm.totalLength += this.getValue('length', docNoFormForm.keyFact4Type)
          this.layoutForm.expLayout += this.getValue('layout', docNoFormForm.keyFact4Type)
          if (docNoFormForm.keyFact4Type === '751' || docNoFormForm.keyFact4Type === '151') {
            docNoFormForm.inclFact4seqNo = false
          }
        }
        if (docNoFormForm.keyFact5Type !== 'NA') {
          this.layoutForm.totalLength += this.getValue('length', docNoFormForm.keyFact5Type)
          this.layoutForm.expLayout += this.getValue('layout', docNoFormForm.keyFact5Type)
          if (docNoFormForm.keyFact5Type === '751' || docNoFormForm.keyFact5Type === '151') {
            docNoFormForm.inclFact5seqNo = false
          }
        }
        if (docNoFormForm.keyFact6Type !== 'NA') {
          this.layoutForm.totalLength += this.getValue('length', docNoFormForm.keyFact6Type)
          this.layoutForm.expLayout += this.getValue('layout', docNoFormForm.keyFact6Type)
          if (docNoFormForm.keyFact6Type === '751' || docNoFormForm.keyFact6Type === '151') {
            docNoFormForm.inclFact6seqNo = false
          }
        }
      } else {
        this.layoutForm.expLayout = '-'
      }
    },
    getValue(returnVal, keyFact) {
      for (var i in this.keyFactList) {
        if (keyFact === this.keyFactList[i].value) {
          if (returnVal === 'length') {
            return this.keyFactList[i].value2
          } else {
            return this.keyFactList[i].value3
          }
        }
      }
    }
  }
}
